import React from 'react';
import './footer.scss';

const FOOTER_LINKS = {
    CONFLUENCE: {
        LABEL: 'Confluence',
        HREF: 'https://confluence.sberbank.ru/pages/viewpage.action?pageId=10188235808',
    },
    CONTACT: {
        LABEL: 'ДЦКБ Дизайн-Маркетинг',
        HREF: 'dcb_uiux_marketing@sberbank.ru',
    },
};

const Footer: React.FC = () => (
    <footer className="footer">
        <div>
            © 1997—{new Date().getFullYear()} ПАО Сбербанк.
            {' | '}
            <a target="_blank" rel="noreferrer" href={FOOTER_LINKS.CONFLUENCE.HREF}>
                {FOOTER_LINKS.CONFLUENCE.LABEL}
            </a>
        </div>
        <div>
            Написать нам
            {' | '}
            <a href={`mailto:${FOOTER_LINKS.CONTACT.HREF}`}>{FOOTER_LINKS.CONTACT.LABEL}</a>
        </div>
    </footer>
);

export default Footer;
